import React from 'react';
import Contributors from './Contributors';

function ModeratorOverview({
  contributors,
  comments,
  variants,
  totalQuestions,
  onlineUsers
}) {
  return (
    <Contributors
      contributors={contributors}
      comments={comments}
      variants={variants}
      totalQuestions={totalQuestions}
      onlineUsers={onlineUsers}
    />
  );
}

export default ModeratorOverview;
